import ConfigurationHistoryTable from "../../components/history-table/configuration-history-table.component";
import {
  getZoneGeneralConfigurationHistory,
  getZoneGeneralConfigurationHistoryDetail,
} from "src/core/api/services/command-module/zone.service";

type ZoneConfigurationHistoryTableProps = {
  isOpen: boolean;
  handleClose: () => void;
  zoneId: number;
  refetchTrigger: number;
};

export function ZoneConfigurationHistoryTable({
  isOpen,
  handleClose,
  zoneId,
  refetchTrigger,
}: ZoneConfigurationHistoryTableProps) {
  return (
    <ConfigurationHistoryTable
      isOpen={isOpen}
      handleClose={handleClose}
      assetCode={`Zone - ${zoneId}`}
      title="Zone Configuration History"
      subtitle="Last 13 months"
      retainedText="Retained for 13 Months"
      actionColumnTitle="Configuration Action"
      actionTitleField="title"
      issueTimeField="sentOn"
      acknowledgeTimeField="ackTime"
      defaultSortBy="SentOn"
      queryKey="getZoneGeneralConfigurationHistory"
      getHistory={(query) =>
        getZoneGeneralConfigurationHistory({
          gatewayZoneId: zoneId,
          ackstatus: String(query.ackstatus || "All").toLowerCase(),
          pageNumber: query.pageNumber,
          searchText: query.searchText ?? null,
          sortBy: query.sortBy,
          sortDirection: query.sortDirection,
          pageSize: query.pageSize,
        })
      }
      getHistoryDetail={getZoneGeneralConfigurationHistoryDetail}
      refetchTrigger={refetchTrigger}
    />
  );
}

export {};